"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTableBaseBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_abstract_dropdown_constants_1 = require("../../molecules/bc-dropdown/bc-abstract-dropdown-constants");
var bc_dropdown_behavior_1 = require("../../molecules/bc-dropdown/bc-dropdown-behavior");
var bc_table_constants_1 = require("./bc-table-constants");
var bc_table_constants_2_1 = require("./bc-table-constants-2");
var BcTableBaseBehavior = (function (_super) {
    __extends(BcTableBaseBehavior, _super);
    function BcTableBaseBehavior() {
        var _this = _super.call(this) || this;
        _this.isSelectionTable = false;
        _this.isSelectionTableRadio = false;
        _this.isSortTable = false;
        _this.isCellActionDropdownHtml = false;
        _this.isCellActionDropdown = false;
        _this.isCellActionInline = false;
        _this.isRowAction = false;
        _this.isNotHidePaginator = false;
        _this.rowsIndexSelected = [];
        _this.selectedRowsElement = [];
        _this.dropdowns = [];
        _this.columnsData = [];
        _this.checkboxcells = [];
        _this.hasSelectionItems = false;
        _this.paginatorsTable = [];
        _this.angularFunction = null;
        _this.dropdownsOptions = [];
        _this.monthsMap = {
            'ene': 'Jan', 'feb': 'Feb', 'mar': 'Mar', 'abr': 'Apr', 'may': 'May', 'jun': 'Jun',
            'jul': 'Jul', 'ago': 'Aug', 'sep': 'Sep', 'oct': 'Oct', 'nov': 'Nov', 'dic': 'Dec'
        };
        _this.monthsIndexMap = {
            'ene': 0, 'feb': 1, 'mar': 2, 'abr': 3, 'may': 4, 'jun': 5,
            'jul': 6, 'ago': 7, 'sep': 8, 'oct': 9, 'nov': 10, 'dic': 11,
            'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
            'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
        };
        return _this;
    }
    BcTableBaseBehavior.setUpAll = function () {
        var tableElements = Array.from(document.querySelectorAll("div[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_CONTAINER_CLASS, "']")));
        var elements = [];
        for (var _i = 0, tableElements_1 = tableElements; _i < tableElements_1.length; _i++) {
            var element = tableElements_1[_i];
            var behavior = new BcTableBaseBehavior();
            behavior.setElement(element);
            behavior.setUp();
            elements.push(behavior);
        }
        return elements;
    };
    BcTableBaseBehavior.prototype._setUp = function () {
        this.getElements();
        this.setColumnId();
        this.getColumnsTitle();
        this.addTooltipToCells();
        this.setCustomWidthColumns();
        this.isSelectionTable = this.table.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_CLASS));
        this.isSelectionTableRadio = this.table.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_RADIO_CLASS));
        this.isSortTable = this.table.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_SORT_CLASS));
        this.isCellActionDropdownHtml = this.table.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_CELL_ACTION_DROPDOWN_CLASS_HTML));
        this.isCellActionDropdown = this.table.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_CELL_ACTION_DROPDOWN_CLASS));
        this.isCellActionInline = this.table.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_CELL_ACTION_INLINE_CLASS));
        this.isRowAction = this.table.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_ROW_ACTION_CLASS));
        this.isNotHidePaginator = this.table.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_NOT_HIDE_PAGINATORS_CLASS));
        this.validateTableVariants();
        this.setAccessibility();
        this.addFocusableTable();
        this.addAriaLabels();
    };
    BcTableBaseBehavior.prototype.getElements = function () {
        this.table = this.mySelf.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_CLASS, "']"));
        this.tbody = Array.from(this.table.getElementsByTagName(bc_table_constants_1.BcTableConstansts.TABLE_TBODY_CLASS))[0];
        this.rows = Array.from(this.table.querySelectorAll("".concat(bc_table_constants_1.BcTableConstansts.TABLE_ROW_CLASS, ":not(.").concat(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CLASS, ")")));
        this.paginatorsTable = Array.from(this.mySelf.querySelectorAll("div[class*=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR_CONTAINER, "\"]")));
        this.columns = Array.from(this.table.querySelectorAll(bc_table_constants_1.BcTableConstansts.TABLE_TH_CLASS));
        this.headerTop = this.mySelf.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_HEADER_TOP_CLASS, "']"));
        this.footer = this.mySelf.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_FOOTER_CLASS, "']"));
        this.headTable = Array.from(this.table.getElementsByTagName(bc_table_constants_1.BcTableConstansts.TABLE_HEAD_CLASS));
        this.tableId = this.mySelf.getAttribute('id');
        this.isSelectionTable = this.table.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_CLASS);
        this.cells = Array.from(this.table.getElementsByTagName(bc_table_constants_1.BcTableConstansts.TABLE_TD_CLASS));
    };
    BcTableBaseBehavior.prototype.addCheckboxEvent = function () {
        var _this = this;
        var masterCheckbox = this.rows[0].querySelector("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]"));
        masterCheckbox.classList.add("".concat(bc_table_constants_1.BcTableConstansts.TABLE_MASTER_CHECKBOX_CLASS));
        var checkboxEvent = function (checkbox, index) {
            checkbox.addEventListener(common_constants_1.BcCommonConstants.EVENT_CHANGE, function (event, _index) {
                if (_index === void 0) { _index = index; }
                var rowSelected = checkbox.closest(bc_table_constants_1.BcTableConstansts.TABLE_ROW_CLASS);
                checkbox[common_constants_1.BcCommonConstants.CHECKED] = event.target[common_constants_1.BcCommonConstants.CHECKED];
                _this.selectUnSelectRow(rowSelected, _index);
                _this.changeHeaderTopType();
                if (_this.selectedRowsElement.length === 0) {
                    _this.removeElementsForSelection();
                }
                else {
                    _this.insertElementsForSelection();
                    _this.updateCounterSelectedRows();
                }
                masterCheckbox[common_constants_1.BcCommonConstants.CHECKED] = _this.validateAllSelection();
            });
        };
        if (masterCheckbox) {
            masterCheckbox.addEventListener(common_constants_1.BcCommonConstants.EVENT_CHANGE, function (event) {
                _this.rows = Array.from(_this.table.querySelectorAll("".concat(bc_table_constants_1.BcTableConstansts.TABLE_ROW_CLASS, ":not(.").concat(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CLASS, ")")));
                masterCheckbox[common_constants_1.BcCommonConstants.CHECKED] || event.target[common_constants_1.BcCommonConstants.CHECKED] ? _this.selectAllRows() : _this.clearSelection();
            });
        }
        if (this.headTable) {
            this.headTable[0].classList.add(bc_table_constants_1.BcTableConstansts.TABLE_THEAD_SELECTABLE);
        }
        this.setEventToCheckbox(checkboxEvent);
    };
    BcTableBaseBehavior.prototype.validateTableVariants = function () {
        var _this = this;
        if (this.isCellActionInline) {
            this.createCellActions(bc_table_constants_1.BcTableConstansts.TABLE_CELL_ACTION_INLINE_CLASS);
        }
        if (this.isRowAction) {
            this.addRowEvent(this.tableRowAction);
        }
        if (this.isCellActionDropdown) {
            this.createCellActions(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CELL_CLASS);
            this.initRowDropdowns();
            window.addEventListener(bc_abstract_dropdown_constants_1._DROPDOWN_OPENED_EVENT, function (dropdownId) {
                _this.closeOtherDropdowns(dropdownId.detail);
            });
        }
        if (this.isCellActionDropdownHtml) {
            this.initRowDropdownsHtml();
            window.addEventListener(bc_abstract_dropdown_constants_1._DROPDOWN_OPENED_EVENT, function (dropdownId) {
                _this.closeOtherDropdowns(dropdownId.detail);
            });
        }
        if (this.isSelectionTable) {
            this.createSelectableElement();
            this.addCheckboxEvent();
        }
        if (this.isSortTable) {
            this.sortColumn();
            this.addHoverIconClass();
        }
        if (window.innerWidth <= Number(bc_table_constants_1.BcTableConstansts.TABLE_MEDIUM_BREAK_POINT)) {
            this.resizeEventForPaginator();
        }
        window.addEventListener('resize', function () {
            _this.resizeEventForPaginator();
        });
    };
    BcTableBaseBehavior.prototype.setEventToCheckbox = function (checkboxEvent) {
        for (var i = 1; i < this.rows.length; i++) {
            var row = this.rows[i];
            var checkbox = row.querySelector("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]"));
            if (checkbox) {
                checkboxEvent(checkbox, i);
            }
        }
    };
    BcTableBaseBehavior.prototype.setSelectionAction = function (actions) {
        this.tableActions = actions;
    };
    BcTableBaseBehavior.prototype.setRowAction = function (action) {
        this.tableRowAction = action;
    };
    BcTableBaseBehavior.prototype.setActionCell = function (actions) {
        this.tableActionCell = actions;
    };
    BcTableBaseBehavior.prototype.createActionButton = function (action) {
        var actionButton;
        if (action.variant == common_constants_1.BcCommonConstants.TAG_TAG) {
            actionButton = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            actionButton.classList.add(common_constants_1.BcCommonConstants.TAG_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_ACTION_BUTTON_CLASS);
            actionButton.innerHTML = "\n        ".concat(action.icon ? "<i class=\"bc-icon bc-xs bc-mx-1\">".concat(action.icon, "</i>") : '', "\n        <p class=\"bc-mx-1\">").concat(action.text, "</p>");
        }
        else {
            var btnType = common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS;
            if (action.variant == 'terciary') {
                btnType = common_constants_1.BcCommonConstants.BTN_TERCIARY_CLASS;
            }
            actionButton = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
            actionButton.classList.add(btnType, common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_ACTION_BUTTON_CLASS);
            actionButton.innerHTML = "\n        ".concat(action.icon ? "<em class=\"bc-icon bc-sm\">".concat(action.icon, "</em>") : '', " \n        ").concat(action.text);
        }
        actionButton.id = "".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_BUTTON, "-").concat(action.id);
        this.addButtonEvent(actionButton, action);
        return actionButton;
    };
    BcTableBaseBehavior.prototype.createTableActions = function (rightContainer) {
        var divElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divElement.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_HEADER_ACTIONS_CLASS);
        for (var _i = 0, _a = this.tableActions; _i < _a.length; _i++) {
            var action = _a[_i];
            var actionButton = this.createActionButton(action);
            divElement.appendChild(actionButton);
        }
        this.headerTop.insertBefore(divElement, rightContainer);
    };
    BcTableBaseBehavior.prototype.addButtonEvent = function (buttonElement, actionButton) {
        var _this = this;
        buttonElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (_this.angularFunction !== null) {
                _this.angularFunction({ rowSelectedIndex: _this.rowsIndexSelected, actionId: actionButton.id });
            }
            if (actionButton.action) {
                actionButton.action({ rowSelectedIndex: _this.rowsIndexSelected, actionId: actionButton.id });
            }
            _this.clearSelection();
        });
    };
    BcTableBaseBehavior.prototype.addCellEvent = function (buttonElement, actionButton, index) {
        buttonElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (actionButton.action) {
                actionButton.action({ rowIndex: index, actionId: actionButton.id });
            }
        });
    };
    BcTableBaseBehavior.prototype.addRowEvent = function (actionRow) {
        var _loop_1 = function (index) {
            this_1.rows[index].addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                var currentEvnt = event.target;
                if (currentEvnt.tagName.toLowerCase() !== common_constants_1.BcCommonConstants.INPUT_TAG
                    && !currentEvnt.classList.contains(common_constants_1.BcCommonConstants.ICONS_CLASS)
                    && !currentEvnt.classList.contains(common_constants_1.BcCommonConstants.CHECKBOX_CLASS)) {
                    if (actionRow.action) {
                        actionRow.action({ rowIndex: index, actionId: actionRow.id });
                    }
                }
            });
        };
        var this_1 = this;
        for (var index = 1; index < this.rows.length; index++) {
            _loop_1(index);
        }
    };
    BcTableBaseBehavior.prototype.selectUnSelectRow = function (row, index) {
        this.toggleSelectedClassRow(row);
        if (!this.selectedRowsElement.includes(row)) {
            this.selectedRowsElement.push(row);
            this.rowsIndexSelected.push(index);
        }
        else {
            this.selectedRowsElement.splice(this.selectedRowsElement.indexOf(row), 1);
            this.rowsIndexSelected.splice(this.rowsIndexSelected.indexOf(index), 1);
        }
    };
    BcTableBaseBehavior.prototype.addHoverIconClass = function () {
        for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
            var element = _a[_i];
            if (!element.querySelector("*[class*=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_SORT_ICON_CLASS, "\"]"))) {
                var iconElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
                iconElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_XS_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_SORT_ICON_HOVER_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
                iconElement.innerHTML = 'exchange';
                if (!element.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_CHECBOX_CELL_CLASS)) {
                    element.appendChild(iconElement);
                }
            }
        }
    };
    BcTableBaseBehavior.prototype.addTooltipToCells = function () {
        for (var _i = 0, _a = this.cells; _i < _a.length; _i++) {
            var element = _a[_i];
            if (element.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_TEXT_CELL_CLASS)) {
                element.classList.add(common_constants_1.BcCommonConstants.BC_TOOLTIP_CLASS);
                element.setAttribute(common_constants_1.BcCommonConstants.BC_TOOLTIP_TEXT, element.innerHTML);
            }
        }
    };
    BcTableBaseBehavior.prototype.toggleSelectedClassRow = function (row) {
        var extra = row.nextElementSibling;
        if (!(row.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_SELECTED_CLASS) &&
            extra &&
            extra.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS))) {
            row.classList.toggle(bc_table_constants_1.BcTableConstansts.TABLE_SELECTED_CLASS);
        }
    };
    BcTableBaseBehavior.prototype.changeHeaderTopType = function () {
        if (this.selectedRowsElement.length === 0) {
            this.headerTop.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_HEADER_TOP_SELECTION_CLASS);
            !this.isNotHidePaginator && this.showPaginatorWhenRowIsNoSelected();
        }
        else {
            this.headerTop.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_HEADER_TOP_SELECTION_CLASS);
            !this.isNotHidePaginator && this.hidePaginatorWhenRowIsSelected();
        }
    };
    BcTableBaseBehavior.prototype.insertElementsForSelection = function () {
        var _this = this;
        var rightContainer = this.headerTop.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_RIGHT_CONTAINER_CLASS, "']"));
        var actionContainer = rightContainer.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CONTAINER_CLASS, "']"));
        var actionButtonElement = this.headerTop.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_BUTTON_CLASS, "']"));
        var counter = document.createElement(common_constants_1.BcCommonConstants.SMALL);
        counter.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_COUNTER_CLASS);
        counter.innerText = '0 elementos seleccionados';
        var unselectLink = document.createElement('a');
        unselectLink.classList.add(common_constants_1.BcCommonConstants.BC_LINK_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_REMOVE_CLASS);
        unselectLink.innerHTML = 'Borrar selección';
        unselectLink.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.clearSelection();
        });
        if (!actionButtonElement) {
            this.createTableActions(rightContainer);
            actionContainer.appendChild(counter);
            actionContainer.appendChild(unselectLink);
        }
    };
    BcTableBaseBehavior.prototype.removeElementsForSelection = function () {
        var actionContainer = this.headerTop.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_HEADER_ACTIONS_CLASS, "']"));
        var counter = this.headerTop.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_COUNTER_CLASS, "']"));
        var unselectLink = this.headerTop.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_REMOVE_CLASS, "']"));
        if (actionContainer) {
            actionContainer.remove();
        }
        if (counter) {
            counter.remove();
        }
        if (unselectLink) {
            unselectLink.remove();
        }
    };
    BcTableBaseBehavior.prototype.selectAllRows = function () {
        for (var i = 1; i < this.rows.length; i++) {
            var row = this.rows[i];
            var checkbox = row.querySelector("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]"));
            if (checkbox && !checkbox.checked) {
                var event_1 = new Event(common_constants_1.BcCommonConstants.EVENT_CHANGE);
                checkbox.dispatchEvent(event_1);
                checkbox[common_constants_1.BcCommonConstants.CHECKED] = true;
            }
        }
    };
    BcTableBaseBehavior.prototype.clearSelection = function () {
        this.selectedRowsElement = [];
        this.rowsIndexSelected = [];
        this.removeElementsForSelection();
        this.changeHeaderTopType();
        for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            row.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_SELECTED_CLASS);
            var checkbox = row.querySelector("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]"));
            if (checkbox) {
                checkbox[common_constants_1.BcCommonConstants.CHECKED] = false;
            }
        }
    };
    BcTableBaseBehavior.prototype.updateCounterSelectedRows = function () {
        var counter = this.headerTop.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_SELECTION_COUNTER_CLASS, "']"));
        counter.innerHTML = "".concat(this.selectedRowsElement.length, " ").concat(this.selectedRowsElement.length > 1 ? 'filas seleccionadas' : 'fila seleccionada');
    };
    BcTableBaseBehavior.prototype.validateAllSelection = function () {
        if (this.rows.length - 1 !== this.selectedRowsElement.length) {
            return false;
        }
        return true;
    };
    BcTableBaseBehavior.prototype.initDropdown = function (element, isStatic) {
        var config = {
            isPopUp: true,
            static: isStatic ? isStatic : false,
        };
        var dropBehavior = new bc_dropdown_behavior_1.BcDropdownBehavior();
        dropBehavior.setElement(element);
        dropBehavior.setConfig(config);
        dropBehavior.setUp();
        return dropBehavior;
    };
    BcTableBaseBehavior.prototype.initRowDropdowns = function () {
        var _a, _b;
        for (var i = 1; i < this.rows.length; i++) {
            var row = this.rows[i];
            var actionCell = row.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CELL_CLASS));
            var dropdown = actionCell && actionCell.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
            if (dropdown !== null) {
                dropdown.setAttribute('id', bc_table_constants_1.BcTableConstansts.TABLE_DROPDOWN + i.toString());
                (_a = dropdown.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_DROPDOWN_CONTENT))) === null || _a === void 0 ? void 0 : _a.setAttribute('id', bc_table_constants_1.BcTableConstansts.TABLE_DROPDOWN_TOGGLE + i.toString());
                (_b = dropdown.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_DROPDOWN_TOGGLE_CLASSS))) === null || _b === void 0 ? void 0 : _b.setAttribute(common_constants_1.BcCommonConstants.ARIA_CONTROL, bc_table_constants_1.BcTableConstansts.TABLE_DROPDOWN_TOGGLE + i.toString());
                var dropBehavior = this.initDropdown(dropdown);
                this.dropdowns.push(dropBehavior);
            }
        }
    };
    BcTableBaseBehavior.prototype.initRowDropdownsHtml = function () {
        for (var i = 1; i < this.rows.length; i++) {
            var row = this.rows[i];
            var actionCell = row.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CELL_CLASS));
            var dropdown = actionCell && actionCell.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
            if (dropdown !== null) {
                var dropBehavior = this.initDropdown(dropdown);
                this.dropdowns.push(dropBehavior);
            }
        }
    };
    BcTableBaseBehavior.prototype.closeOtherDropdowns = function (noCloseId) {
        for (var _i = 0, _a = this.dropdowns; _i < _a.length; _i++) {
            var dropdown = _a[_i];
            if (dropdown.idContent !== noCloseId && !dropdown.config.static) {
                dropdown.closeDropdown();
            }
        }
    };
    BcTableBaseBehavior.prototype.sortColumn = function () {
        var _this = this;
        var tbody = this.table.querySelector('tbody');
        this.columns.forEach(function (column) {
            if (!column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_CHECBOX_CELL_CLASS) &&
                !column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_COLUMN_CLASS)) {
                _this.addColumnSortEvent(column, tbody);
            }
        });
    };
    BcTableBaseBehavior.prototype.addColumnSortEvent = function (column, tbody) {
        var _this = this;
        column.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.columnSortEvent(column, tbody);
        });
        column.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.code == common_constants_1.BcCommonConstants.KEY_EVENT_SPACE || event.key == common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                _this.columnSortEvent(column, tbody);
            }
        });
    };
    BcTableBaseBehavior.prototype.columnSortEvent = function (column, tbody) {
        this.addSortIcon(column);
        this.asc = !this.asc;
        Array.from(tbody.querySelectorAll("tr:not([class*=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA, "\"])")))
            .sort(this.comparer(Array.from(column.parentNode.children).indexOf(column), this.asc))
            .forEach(function (tr) { return tbody.appendChild(tr); });
        if (!this.table.classList.contains(bc_table_constants_2_1.BcTableConstansts2.TABLE_SCROLL_CLASS)) {
            window.dispatchEvent(new CustomEvent(bc_table_constants_2_1.BcTableConstansts2.TABLE_SORT_EVENT));
        }
    };
    BcTableBaseBehavior.prototype.addSortIcon = function (column) {
        for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
            var colum = _a[_i];
            var icon = colum.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_SORT_ICON_CLASS));
            var iconHover = colum.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_SORT_ICON_HOVER_CLASS));
            if (icon) {
                icon.remove();
            }
            if (iconHover) {
                iconHover.remove();
            }
        }
        var iconElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        iconElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_XS_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_SORT_ICON_CLASS);
        iconElement.innerText = this.asc ? common_constants_1.BcCommonConstants.BC_ARROW_DOWN_ICON : common_constants_1.BcCommonConstants.BC_ARROW_UP_ICON;
        column.appendChild(iconElement);
        this.addHoverIconClass();
    };
    BcTableBaseBehavior.prototype.getCellValue = function (tr, idx) {
        var _a, _b;
        var rawValue = ((_b = (_a = tr.children[idx]) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || '';
        return this.cleanCellValue(rawValue);
    };
    BcTableBaseBehavior.prototype.cleanCellValue = function (value) {
        var cleanedValue = value.trim();
        cleanedValue = cleanedValue.replace(bc_table_constants_1.BcTableConstansts.CURRENCY_PREFIX_REGEX, '');
        cleanedValue = cleanedValue.replace(bc_table_constants_1.BcTableConstansts.CURRENCY_SYMBOLS_REGEX, '');
        cleanedValue = cleanedValue.replace(bc_table_constants_1.BcTableConstansts.THOUSANDS_SEPARATOR_REGEX, '').replace(bc_table_constants_1.BcTableConstansts.DECIMAL_SEPARATOR_REGEX, '.');
        if (bc_table_constants_1.BcTableConstansts.NUMBER_VALIDATION_REGEX.test(cleanedValue)) {
            return cleanedValue;
        }
        return value.trim();
    };
    BcTableBaseBehavior.prototype.comparer = function (idx, asc) {
        var _this = this;
        return function (a, b) {
            var _a;
            var valueA = _this.normalizeCellValue(_this.getCellValue(a, idx));
            var valueB = _this.normalizeCellValue(_this.getCellValue(b, idx));
            if (!asc) {
                _a = [valueB, valueA], valueA = _a[0], valueB = _a[1];
            }
            if (_this.areDates(valueA, valueB)) {
                return new Date(valueA).getTime() - new Date(valueB).getTime();
            }
            if (_this.areNumbers(valueA, valueB)) {
                return Number(valueA) - Number(valueB);
            }
            return valueA.toString().localeCompare(valueB.toString(), undefined, { numeric: true, sensitivity: 'base' });
        };
    };
    BcTableBaseBehavior.prototype.normalizeCellValue = function (value) {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        var cleanedValue = this.cleanCellValue(value);
        if (cleanedValue === '') {
            return '';
        }
        var parsedDate = this.parseDate(cleanedValue);
        if (parsedDate) {
            return parsedDate;
        }
        var numericValue = Number(cleanedValue);
        return isNaN(numericValue) ? cleanedValue : numericValue;
    };
    BcTableBaseBehavior.prototype.parseDate = function (value) {
        var parsers = [
            { regex: /^(\d{2})\/(\d{2})\/(\d{4})$/, parser: this.createValidDateFromParts.bind(this) },
            { regex: /^(\d{2}) (\w{3}) (\d{4})$/i, parser: this.createValidDateFromShortMonth.bind(this) },
            { regex: /^(\d{2})\/(\d{2})\/(\d{4}) - (\d{2}):(\d{2})$/, parser: this.createValidDateWithTime24h.bind(this) },
            { regex: /^(\d{2})\/(\d{2})\/(\d{4}) - (\d{1,2}):(\d{2}) (a\.m\.|p\.m\.)$/i, parser: this.createValidDateWithTime12h.bind(this) },
            { regex: /^(\d{2}) (\w{3}) (\d{4}) - (\d{2}):(\d{2})$/, parser: this.createValidDateFromShortMonthWithTime24h.bind(this) },
            { regex: /^(\d{2}) (\w{3}) (\d{4}) - (\d{1,2}):(\d{2}) (a\.m\.|p\.m\.)$/i, parser: this.createValidDateFromShortMonthWithTime12h.bind(this) },
        ];
        for (var _i = 0, parsers_1 = parsers; _i < parsers_1.length; _i++) {
            var _a = parsers_1[_i], regex = _a.regex, parser = _a.parser;
            var parsedDate = this.parseDateFormat(value, regex, parser);
            if (parsedDate) {
                return parsedDate;
            }
        }
        return null;
    };
    BcTableBaseBehavior.prototype.parseDateFormat = function (value, regex, parser) {
        var matches = value.match(regex);
        return matches ? parser(matches) : null;
    };
    BcTableBaseBehavior.prototype.createValidDateFromParts = function (matches) {
        var _a = matches.map(Number), day = _a[1], month = _a[2], year = _a[3];
        return this.createValidDate(year, month, day);
    };
    BcTableBaseBehavior.prototype.createValidDateFromShortMonth = function (matches) {
        var day = matches[1], monthStr = matches[2], year = matches[3];
        var month = this.monthsMap[monthStr.toLowerCase()];
        return month !== undefined ? this.createValidDate(Number(year), month, Number(day)) : null;
    };
    BcTableBaseBehavior.prototype.createValidDateWithTime24h = function (matches) {
        var day = matches[1], monthStr = matches[2], year = matches[3], hours = matches[4], minutes = matches[5];
        var month = Number(monthStr) - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1;
        return month !== undefined ? new Date(Number(year), month, Number(day), Number(hours), Number(minutes)) : null;
    };
    BcTableBaseBehavior.prototype.createValidDateWithTime12h = function (matches) {
        var day = matches[1], monthStr = matches[2], year = matches[3], hours = matches[4], minutes = matches[5], meridian = matches[6];
        var month = Number(monthStr) - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1;
        var time24h = this.convertTo24hFormat(Number(hours), meridian);
        return month !== undefined ? new Date(Number(year), month, Number(day), time24h, Number(minutes)) : null;
    };
    BcTableBaseBehavior.prototype.createValidDateFromShortMonthWithTime24h = function (matches) {
        var day = matches[1], monthStr = matches[2], year = matches[3], hours = matches[4], minutes = matches[5];
        var month = this.monthsIndexMap[monthStr.toLowerCase()];
        return month !== undefined ? new Date(Number(year), month, Number(day), Number(hours), Number(minutes)) : null;
    };
    BcTableBaseBehavior.prototype.createValidDateFromShortMonthWithTime12h = function (matches) {
        var day = matches[1], monthStr = matches[2], year = matches[3], hours = matches[4], minutes = matches[5], meridian = matches[6];
        var month = this.monthsIndexMap[monthStr.toLowerCase()];
        var time24h = this.convertTo24hFormat(Number(hours), meridian);
        return month !== undefined ? new Date(Number(year), month, Number(day), time24h, Number(minutes)) : null;
    };
    BcTableBaseBehavior.prototype.convertTo24hFormat = function (hours, meridian) {
        var PM_HOUR = common_constants_1.COMMON_CONSTANTS_NUMBERS.N12;
        var lowerMeridian = meridian.toLowerCase();
        if (lowerMeridian === bc_table_constants_1.BcTableConstansts.FORMAT_PM && hours < PM_HOUR) {
            return hours + PM_HOUR;
        }
        if (lowerMeridian === bc_table_constants_1.BcTableConstansts.FORMAT_AM && hours === PM_HOUR) {
            return common_constants_1.COMMON_CONSTANTS_NUMBERS.N0;
        }
        return hours;
    };
    BcTableBaseBehavior.prototype.createValidDate = function (year, month, day) {
        var parsedDate;
        if (typeof month === 'string') {
            parsedDate = new Date("".concat(month, " ").concat(day, ", ").concat(year));
        }
        else {
            parsedDate = new Date(year, month - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1, day);
        }
        var isValidDate = parsedDate.getDate() === day &&
            parsedDate.getMonth() === (typeof month === 'string' ? parsedDate.getMonth() : month - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1);
        return isValidDate ? parsedDate : null;
    };
    BcTableBaseBehavior.prototype.areNumbers = function (v1, v2) {
        return !isNaN(v1) && !isNaN(v2);
    };
    BcTableBaseBehavior.prototype.areDates = function (v1, v2) {
        return v1 instanceof Date && v2 instanceof Date;
    };
    BcTableBaseBehavior.prototype.createCellActions = function (cellClass) {
        this.removeActionTh();
        var element;
        for (var index = 0; index < this.rows.length; index++) {
            if (index == 0) {
                element = document.createElement(bc_table_constants_1.BcTableConstansts.TABLE_TH_CLASS);
                element.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_COLUMN_CLASS);
                this.rows[index].appendChild(element);
            }
            else {
                element = document.createElement(bc_table_constants_1.BcTableConstansts.TABLE_TD_CLASS);
                this.rows[index].appendChild(element);
                (0, helpers_1.addFocusable)(element, { tabindex: '0' });
                if (this.isCellActionInline && this.tableActionCell.length <= Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_3)) {
                    element.classList.add(cellClass);
                    this.createInlineCellActions(element, index);
                }
                else {
                    element.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CELL_CLASS);
                    this.createDropdownCellActions(element, index);
                }
            }
        }
    };
    BcTableBaseBehavior.prototype.createInlineCellActions = function (element, index) {
        for (var j = 0; j < this.tableActionCell.length; j++) {
            var btnElement = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
            (0, helpers_1.addFocusable)(btnElement, { tabindex: '0' });
            btnElement.classList.add(common_constants_1.BcCommonConstants.BC_BUTTON_ICON_CLASS, common_constants_1.BcCommonConstants.BC_TOOLTIP_CLASS);
            btnElement.setAttribute(common_constants_1.BcCommonConstants.BC_TOOLTIP_TEXT, this.tableActionCell[j].text);
            btnElement.innerHTML += "<em class=\"bc-icon bc-sm\">".concat(this.tableActionCell[j].icon, "</em>");
            this.addCellEvent(btnElement, this.tableActionCell[j], index);
            element.appendChild(btnElement);
        }
    };
    BcTableBaseBehavior.prototype.createDropdownCellActions = function (element, index) {
        var dropdownElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        dropdownElement.classList.add(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS);
        dropdownElement.innerHTML += "<em class=\"bc-dropdown-toggle bc-icon bc-sm\">secondary-menu</em>\n                   <div class=\"bc-dropdown-content\">\n                     <ul> </ul></div>";
        element.appendChild(dropdownElement);
        for (var _i = 0, _a = this.tableActionCell; _i < _a.length; _i++) {
            var actionCell = _a[_i];
            var dropdownOptionElement = document.createElement('li');
            (0, helpers_1.addFocusable)(dropdownOptionElement, { tabindex: '0' });
            dropdownOptionElement.classList.add('bc-dropdown-item');
            dropdownOptionElement.innerHTML += "\n        <a class=\"bc-link\" id=\"".concat(actionCell.icon, "Option\" aria-action-id=\"").concat(actionCell.icon, "\">\n          <em class=\"bc-icon bc-sm\">").concat(actionCell.icon, "</em>\n          <span>").concat(actionCell.text, "</span>\n        </a>\n      ");
            dropdownElement.getElementsByTagName('ul')[0].appendChild(dropdownOptionElement);
            this.addCellEvent(dropdownOptionElement, actionCell, index);
        }
    };
    BcTableBaseBehavior.prototype.resizeEventForPaginator = function () {
        if (window.innerWidth <= Number(bc_table_constants_1.BcTableConstansts.TABLE_MEDIUM_BREAK_POINT)) {
            !this.inMobileSize && this.movePaginatorDown();
            this.inMobileSize = true;
        }
        else {
            this.removeMobileClassPag();
            this.inMobileSize = false;
        }
    };
    BcTableBaseBehavior.prototype.movePaginatorDown = function () {
        var paginatorContainers = Array.from(this.mySelf.querySelectorAll(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR_CONTAINER)));
        var paginatorContainerBellow = paginatorContainers[paginatorContainers.length - Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_1)];
        var paginator = this.mySelf.querySelectorAll(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR));
        if (paginator.length === Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_1)) {
            paginator[bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_0].classList.add(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR_MOBILE);
            paginatorContainerBellow.appendChild(paginator[bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_0]);
        }
        else if (paginator.length === Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_2)) {
            if (!paginator[bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_0].classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR_MOBILE) &&
                !paginator[bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_1].classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR_MOBILE)) {
                paginator[bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_0].classList.add(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR_MOBILE);
                paginatorContainerBellow.appendChild(paginator[bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_0]);
            }
        }
    };
    BcTableBaseBehavior.prototype.removeMobileClassPag = function () {
        var paginatorMobile = this.mySelf.querySelector("*[class*=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR_MOBILE, "\"]"));
        if (paginatorMobile !== null) {
            paginatorMobile.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR_MOBILE);
            var paginatorContainer = this.headerTop.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR_CONTAINER));
            paginatorContainer !== null && paginatorContainer.appendChild(paginatorMobile);
        }
        var paginators = this.mySelf.querySelectorAll("nav[class*=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_PAGINATOR, "\"]"));
        if (paginators.length <= Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_1)) {
            var subcontainer = this.mySelf.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_FOOTER_SUBCONTAINER));
            subcontainer !== null && subcontainer.remove();
        }
    };
    BcTableBaseBehavior.prototype.setColumnId = function () {
        for (var i = Number(bc_table_constants_1.BcTableConstansts.TABLE_NUMBER_0); i < this.columns.length; i++) {
            var column = this.columns[i];
            column.setAttribute('id', "".concat(this.tableId, "_column_").concat(i));
        }
    };
    BcTableBaseBehavior.prototype.getColumnsTitle = function () {
        for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
            var column = _a[_i];
            var columnName = column['textContent'].split(/\n/)[0];
            columnName = columnName.replace(/exchange/g, '');
            if (columnName !== '' && columnName.length > 0) {
                this.columnsData.push({
                    id: column.getAttribute('id'),
                    name: columnName,
                });
            }
        }
    };
    BcTableBaseBehavior.prototype.setCustomWidthColumns = function () {
        for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
            var column = _a[_i];
            var customWidth = column.getAttribute('table-column-width');
            if (customWidth) {
                column.setAttribute('width', customWidth);
            }
        }
    };
    BcTableBaseBehavior.prototype.createSelectableElement = function () {
        this.removeCheckboxes();
        if (!this.hasSelectionItems) {
            for (var index = 0; index < this.rows.length; index++) {
                var type = 'td';
                var ariamessage = 'Seleccionar fila, no seleccionado, casilla de verificación.';
                if (index === 0) {
                    type = 'th';
                    ariamessage = 'Seleccionar todas las filas, no seleccionado, casilla de verificación.';
                }
                var checkboxElement = document.createElement(type);
                checkboxElement.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_CHECBOX_CELL_CLASS);
                checkboxElement.innerHTML += "<label class=\"bc-container-checkbox\"><input type=\"checkbox\"/><span class=\"bc-checkbox\"></span></label>";
                (0, helpers_1.addFocusable)(checkboxElement, { tabindex: '0' });
                checkboxElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, ariamessage);
                this.rows[index].prepend(checkboxElement);
            }
        }
        this.hasSelectionItems = true;
    };
    BcTableBaseBehavior.prototype.removeCheckboxes = function () {
        this.checkboxcells = Array.from(this.table.querySelectorAll("[class~=".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECBOX_CELL_CLASS, "]")));
        for (var _i = 0, _a = this.checkboxcells; _i < _a.length; _i++) {
            var checkboxElm = _a[_i];
            checkboxElm.remove();
        }
    };
    BcTableBaseBehavior.prototype.removeActionTh = function () {
        this.checkboxcells = Array.from(this.table.querySelectorAll("[class~=".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_COLUMN_CLASS)));
        for (var _i = 0, _a = this.checkboxcells; _i < _a.length; _i++) {
            var checkboxElm = _a[_i];
            checkboxElm.remove();
        }
    };
    BcTableBaseBehavior.prototype.getCurrentElement = function (index) {
        return this.rows[index];
    };
    BcTableBaseBehavior.prototype.setAccessibility = function () {
        var _this = this;
        this.rows.forEach(function (element, index) {
            _this.addScreenReader(element, index);
        });
    };
    BcTableBaseBehavior.prototype.addScreenReader = function (element, index) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                _this.focusNext(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
                _this.focusBack(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
                _this.focusHomeEnd(index, true);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_PAGE_DOWN) {
                _this.focusHomeEnd(index);
            }
        });
    };
    BcTableBaseBehavior.prototype.focusHomeEnd = function (index, key) {
        if (key === void 0) { key = false; }
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (key) {
                index = 0;
            }
            else {
                index = this.rows.length - 1;
            }
            this.getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    };
    BcTableBaseBehavior.prototype.focusNext = function (index) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index < this.rows.length - 1) {
                index++;
            }
            else {
                index = 0;
            }
            this.getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    };
    BcTableBaseBehavior.prototype.focusBack = function (index) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
            }
            else {
                index = this.rows.length - 1;
            }
            this.getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    };
    BcTableBaseBehavior.prototype.addFocusableTable = function () {
        for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
            var column = _a[_i];
            if (!column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS)) {
                (0, helpers_1.addFocusable)(column, { tabindex: '0' });
            }
        }
        for (var _b = 0, _c = this.rows; _b < _c.length; _b++) {
            var row = _c[_b];
            if (!row.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CLASS)) {
                (0, helpers_1.addFocusable)(row, { tabindex: '0' });
            }
        }
    };
    BcTableBaseBehavior.prototype.hidePaginatorWhenRowIsSelected = function () {
        for (var _i = 0, _a = this.paginatorsTable; _i < _a.length; _i++) {
            var paginator = _a[_i];
            paginator.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
        }
    };
    BcTableBaseBehavior.prototype.showPaginatorWhenRowIsNoSelected = function () {
        for (var _i = 0, _a = this.paginatorsTable; _i < _a.length; _i++) {
            var paginator = _a[_i];
            paginator.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
        }
    };
    BcTableBaseBehavior.prototype.addAriaLabels = function () {
        var topTitle = this.headerTop.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_HEADER_TITLE_CLASS, "']"));
        this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, (topTitle === null || topTitle === void 0 ? void 0 : topTitle.innerHTML) + ', tabla, ' + this.rows.length + ' filas, ' + this.columns.length + ' columnas');
        topTitle === null || topTitle === void 0 ? void 0 : topTitle.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, topTitle.innerHTML);
    };
    BcTableBaseBehavior.prototype.getListenersHmtl = function () {
        var _a;
        for (var _i = 0, _b = this.rows; _i < _b.length; _i++) {
            var row = _b[_i];
            var dropdown = row.querySelector("*[class^=\"".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS, "\"]"));
            var isDisabledDropdown = (_a = dropdown === null || dropdown === void 0 ? void 0 : dropdown.classList.contains('disabled')) !== null && _a !== void 0 ? _a : false;
            var optionsList = dropdown ? dropdown.querySelectorAll(common_constants_1.BcCommonConstants.HREF_TAG) : null;
            var options = [];
            if (optionsList) {
                for (var _c = 0, _d = Array.from(optionsList); _c < _d.length; _c++) {
                    var option = _d[_c];
                    var id = option.getAttribute(common_constants_1.BcCommonConstants.ARIA_ACTION_ID);
                    var icon = this.getElementText(option, common_constants_1.BcCommonConstants.EM_TAG);
                    var text = this.getElementText(option, common_constants_1.BcCommonConstants.SPAN_TAG);
                    var action = option.onclick;
                    options.push({ id: id, icon: icon, text: text, action: action, disabled: isDisabledDropdown });
                }
                this.dropdownsOptions.push(options);
            }
        }
    };
    BcTableBaseBehavior.prototype.getElementText = function (option, selector) {
        var element = option.querySelector(selector);
        return element instanceof HTMLElement ? element.innerText : '';
    };
    BcTableBaseBehavior.prototype.closeCurrentExtraInfoRow = function () {
        var extraRows = Array.from(this.table.querySelectorAll("tr[class*=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS, "\"]")));
        for (var _i = 0, extraRows_1 = extraRows; _i < extraRows_1.length; _i++) {
            var row = extraRows_1[_i];
            row.classList.replace(bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS, bc_table_constants_1.BcTableConstansts.TABLE_EXTRA_ROW_CLASS);
        }
    };
    return BcTableBaseBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcTableBaseBehavior = BcTableBaseBehavior;
